export const textTruncate = (text) => {
  if (!text) return '';
  const str = String(text);
  
  // Check if string has space or not
  const hasSpaces = str.includes(' ');
  
  if (hasSpaces) {
    // if it contains space cut at 3rd word
    const words = str.split(' ');
    if (words.length > 3) {
      return words.slice(0, 3).join(' ') + '...';
    }
    return str;
  } else {
    // if it doesn't contains spaces cut at 12th character
    if (str.length > 12) {
      return str.slice(0, 12) + '...';
    }
    return str || '';
  }
};